import { FC } from 'react';
import UIFileDropzoneV2 from 'components/Others/UIFileDropzoneV2';
const ALLOWED_MAX_PRESCRIPTION_FILE_SIZE_MB = 3;
export const ALLOWED_FILE_EXTENSIONS = ['jpg', 'png', 'jpeg', 'pdf'];
const ACCEPT_ATTRIBUTE = 'image/png, image/jpeg, application/pdf';

interface PrescriptionUploadDropzoneProps {
  // eslint-disable-next-line no-unused-vars
  onFileSelected: (selectedFile: File) => void;
  cancelFileSelected?: () => void;
}

const PrescriptionUploadDropzone: FC<PrescriptionUploadDropzoneProps> = ({
  onFileSelected,
  cancelFileSelected
}) => {
  return (
    <div>
        <UIFileDropzoneV2
          description={
            <p>
              You can upload your prescription, your file size must be lower
              than{' '}
              <span className="font-medium">
                {ALLOWED_MAX_PRESCRIPTION_FILE_SIZE_MB}MB
              </span>{' '}
              and allowed file extensions are{' '}
              <span className="font-medium">{ALLOWED_FILE_EXTENSIONS.join(', ')}</span>.
            </p>
          }
          buttonText="Browse your prescription"
          onFileSelected={onFileSelected}
          cancelFileSelected={cancelFileSelected}
          resizeImages
          maximumFileSizeMB={ALLOWED_MAX_PRESCRIPTION_FILE_SIZE_MB}
          allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
          accept={ACCEPT_ATTRIBUTE}
        />
    </div>
  );
};

export default PrescriptionUploadDropzone;
